<template>
    <AssetList :all="isAll" :assets="assets" />
</template>

<script>
import { mapGetters, mapState } from 'vuex'

import AssetList from '../AssetList'

export default {
    name: 'AssetListView',
    components: {
        AssetList,
    },
    props: {
        type: {
            type: String,
            required: true,
        },
    },
    computed: {
        ...mapState('tracker', ['trackers']),
        ...mapGetters('tracker', ['assetsInLocation']),
        assets() {
            switch (this.type) {
                case 'ASSET_TYPE':
                    return this.trackers.filter(
                        tracker =>
                            tracker.asset_details.asset_type_identifier ===
                            this.$route.params.assetType
                    )
                case 'ASSETS_ALL':
                    return this.trackers
                case 'LOCATION':
                    return this.assetsInLocation(this.$route.params.location)
                default:
                    console.error('Unkown asset type')
                    return []
            }
        },
        isAll() {
            return this.type === 'ASSETS_ALL'
        },
    },
}
</script>
